import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useMilitaryChartsDataContext } from './hooks/useMilitaryChartsDataContext';
import { useMemo } from 'react';

const monthNames = [
    'Jan',
    'Fev',
    'Mar',
    'Abr',
    'Maio',
    'Jun',
    'Jul',
    'Ago',
    'Set',
    'Out',
    'Nov',
    'Dez'
];

const getMonthLabel = (mes) => {
    const monthIndex = parseInt(mes) - 1;
    const monthName = monthNames[monthIndex] || mes;
    return `${monthName}`;
};

export const CompanyEvolutionMonth = () => {
    const { chartData } = useMilitaryChartsDataContext();

    // Transform data to show each company (cia) evolution by month
    const { series, categories } = useMemo(() => {
        let monthData = chartData?.companyEvolutionMonth || [];
        
        if (!monthData.length) {
            return { series: [], categories: [] };
        }

        // Sort data chronologically by year and month
        monthData = [...monthData].sort((a, b) => {
            const yearDiff = parseInt(a.ano_estatistica) - parseInt(b.ano_estatistica);
            if (yearDiff !== 0) return yearDiff;
            return parseInt(a.mes_estatistica) - parseInt(b.mes_estatistica);
        });

        // Limit to 12 consecutive months (last 12)
        monthData = monthData.slice(-12);

        // Get all unique companies
        const cmdsSet = new Set();
        monthData.forEach(period => {
            period.cias?.forEach(cia => {
                cmdsSet.add(cia.cia);
            });
        });

        // Create series for each company
        const cmdSeries = Array.from(cmdsSet).map(cmdName => {
            const data = monthData.map(period => {
                const cmdData = period.cias?.find(c => c.cia === cmdName);
                return cmdData?.total || 0;
            });
            return {
                name: cmdName,
                data: data
            };
        });

        // Get month/year as categories
        const monthCategories = monthData.map(item => 
            getMonthLabel(item.mes_estatistica)
        );

        return {
            series: cmdSeries,
            categories: monthCategories
        };
    }, [chartData?.companyEvolutionMonth]);

    return (
        <SimpleBars
            title={'Ocorrências por Companhia (Mensal)'}
            horizontal={false}
            stacked={true}
            subtitles={categories}
            series={series}
            isMoney={false}
            showDataLabels={false}
        />
    );
};